import SponsorsFlexBox from '@/components/modules/SponsorsFlexBox';
import { Maybe, Organization, PbsKidsProperty } from '@/types/pbskids-graph';
import styles from './ProducerSponsors.module.scss';

type ProducerSponsorsProps = {
  propertyData: PbsKidsProperty;
  sponsorLogoTheme?: Maybe<string>;
};

export default function ProducerSponsors({ propertyData, sponsorLogoTheme }: ProducerSponsorsProps) {
  return <div className={styles.producerSponsorsWrapper}>
    <div className={styles.topTier}>
      { !!propertyData?.producers?.length && <SponsorsFlexBox
        title='Produced by'
        list={propertyData.producers as Organization[]}
        logoTheme={sponsorLogoTheme}
      /> }

      { !!propertyData?.majorFunders?.length && <SponsorsFlexBox
        title='Major Funding by'
        list={propertyData.majorFunders as Organization[]}
        logoTheme={sponsorLogoTheme}
      /> }
    </div>

    { !!propertyData?.additionalFunders?.length && <SponsorsFlexBox
      title='Additional Funding by'
      list={propertyData.additionalFunders as Organization[]}
      logoTheme={sponsorLogoTheme}
    /> }
  </div>;
}
